import { createAsyncThunk } from '@reduxjs/toolkit';
import { updateConnectwiseContact } from 'services/pod';
import { ICWContactUpdatePayload } from 'services/pod/types';

export const ThunkUpdatePsaContact = createAsyncThunk<
  { type: string; value: string },
  ICWContactUpdatePayload
>('pod/updatePsaContact', async payload => {
  await updateConnectwiseContact(payload).then(r => r.data);

  return {
    type: payload.itemName,
    value: payload.value,
  };
});
